import { Link } from "react-router-dom";
import { Lock } from "lucide-react";

export const hasPrice = (v) => v !== null && v !== undefined && !Number.isNaN(Number(v));

export const fmtMXN = (v) => `$${Number(v).toLocaleString("es-MX")}`;
export const fmtUSD = (v) => `$${Number(v).toLocaleString("en-US")}`;

/* Compact lock shown wherever a price would appear for visitors without session. */
export const PriceLock = ({ lang = "es", size = "md", next = "/servicios", testId = "price-lock" }) => (
  <Link
    to={`/registro?next=${encodeURIComponent(next)}`}
    data-testid={testId}
    className={`inline-flex items-center gap-1.5 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 text-[#d4af37] hover:bg-[#d4af37]/20 transition-colors ${
      size === "sm" ? "px-2.5 py-1 text-[10px]" : "px-3.5 py-1.5 text-[11px]"
    } uppercase tracking-widest`}
  >
    <Lock className={size === "sm" ? "w-3 h-3" : "w-3.5 h-3.5"} />
    {lang === "es" ? "Regístrate para ver precio" : "Sign up to see price"}
  </Link>
);

export default PriceLock;
